import React, { useState } from "react";
import "./ProfileCards.css";

import MainButton from "../Elements/MainButton/MainButton";
import SecondButton from "../Elements/SecondButton/SecondButton";
import LinkButton from "../Elements/LinkButton/LinkButton";

import WalletEditModal from "./WalletEditModal";
import TransferModal from "./TransferModal";
import WalletIdModal from "./WalletIdModal";
import TopUpModal from "./TopUpModal";

const WalletSummaryCard = ({ wallet, token, userId, onRefreshData }) => {
  const [isIdOpen, setIsIdOpen] = useState(false);
  const [isTransferOpen, setIsTransferOpen] = useState(false);
  const [isTopUpOpen, setIsTopUpOpen] = useState(false);
  const [isEditOpen, setIsEditOpen] = useState(false);

  const { balance, currency, id } = wallet;

  const handleOpenTransfer = () => setIsTransferOpen(true);

  const handleTransferSuccess = async () => {
    try {
      await onRefreshData();
    } catch (err) {
      console.error("Refresh failed after transfer");
    }
  };

  const handleTopUpSuccess = async () => {
    console.log("🔄 TopUp success → refresh!");
    try {
      await onRefreshData();
    } catch (err) {
      console.error("TopUp refresh failed:", err);
    }
  };

  const handleWalletUpdated = async () => {
    try {
      await onRefreshData();
      setIsEditOpen(false);
    } catch (err) {
      console.error("Refresh failed after wallet update");
    }
  };

  return (
    <>
      <section className="summary-card summary-card--wallet">
        <div>
          <p className="summary-balance-label">Balance</p>
          <p className="summary-balance">
            {balance.toLocaleString("en-US", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })}{" "}
            {currency}
          </p>
          {id && (
            <LinkButton className="wallet-id-link" onClick={() => setIsIdOpen(true)}>
              Show wallet ID
            </LinkButton>
          )}
        </div>

        <div className="summary-actions">
          <SecondButton className="summary-btn summary-btn--secondary" onClick={() => setIsEditOpen(true)}>
            Edit
          </SecondButton>
          <SecondButton className="summary-btn summary-btn--primary" onClick={handleOpenTransfer}>
            Transfer
          </SecondButton>
          <MainButton className="summary-btn summary-btn--primary" onClick={() => setIsTopUpOpen(true)}>
            Top-Up
          </MainButton>
        </div>
      </section>

      {id && <WalletIdModal isOpen={isIdOpen} onClose={() => setIsIdOpen(false)} id={id} />}

      <TransferModal
        isOpen={isTransferOpen}
        onClose={() => setIsTransferOpen(false)}
        userId={userId}
        token={token}
        fromWalletId={id}
        currency={currency}
        balance={balance}
        onTransferred={handleTransferSuccess}
      />
      <TopUpModal
        isOpen={isTopUpOpen}
        onClose={() => setIsTopUpOpen(false)}
        token={token}
        walletId={id}
        currency={currency}
        onToppedUp={handleTopUpSuccess}
      />
      <WalletEditModal
        isOpen={isEditOpen}
        onClose={() => setIsEditOpen(false)}
        wallet={wallet}
        token={token}
        onUpdated={handleWalletUpdated}
      />
    </>
  );
};

export default WalletSummaryCard;
